import React from 'react';
import PageCard from 'features/shared/components/card/PageCard';
import { Ets2AffidavitAuthorizedPersonDTO } from '../dtos/Ets2AffidavitAuthorizedPersonDTO';
import { useTranslation } from 'react-i18next';
import InfoItem from 'features/shared/components/infoItem/InfoItem';

interface Props { person: Ets2AffidavitAuthorizedPersonDTO; }

const Ets2AffidavitAuthorizedPersonCard = ({ person }: Props) => {
  // translations
  const t = useTranslation('ets2\\ets2').t;
  const tTerms = useTranslation('shared\\terms').t;

  // computed values
  const authorizationValue =
    person.authorizationToAct === undefined
      ? '—'
      : tTerms(person.authorizationToAct ? 'Yes' : 'No');

  // render
  return (
    <PageCard title={t('ets2AffidavitAuthorizedPersonCard.title')}>    
      <div className="row g-3">
        <div className="col-sm-6 col-xl-3 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={t('ets2AffidavitAuthorizedPersonCard.firstName')}
            value={person.firstName || '—'}
            icon="id-badge"
          />
        </div>
        <div className="col-sm-6 col-xl-3 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={t('ets2AffidavitAuthorizedPersonCard.lastName')}
            value={person.lastName || '—'}
            icon="id-badge"
          />
        </div>
        <div className="col-sm-6 col-xl-3 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={t('ets2AffidavitAuthorizedPersonCard.position')}
            value={person.position || '—'}
            icon="flag"
          />
        </div>
        <div className="col-sm-6 col-xl-3 px-sm-3 pb-2 pb-sm-3">
          <InfoItem
            title={t('ets2AffidavitAuthorizedPersonCard.authorizationToAct')}
            value={authorizationValue}
            icon="stamp"
          />
        </div>
      </div>
    </PageCard>
  );
};

export default Ets2AffidavitAuthorizedPersonCard;
